import appGlobalScript from '/home/pierre/WARP10src/discovery/discovery-plugins/discovery-plugin-marauder/src/plugin.ts';
export const globalScripts = appGlobalScript;
